// extracted by mini-css-extract-plugin
export default {"wrapper":"lockerConfiguration_wrapper__HdISa","form":"lockerConfiguration_form__Hb8ep","codesLink":"lockerConfiguration_codesLink__rK8Rd"};